import React from 'react';
import { useTranslation } from 'react-i18next';
import './DemoDownloadButton.css';

/**
 * Demo download button. Renders a disabled placeholder when no demo exists,
 * otherwise opens the demo URL in a new tab.
 *
 * @param {Object} props
 * @param {string} props.demoUrl - URL to the demo file.
 * @param {boolean} props.hasDemo - Whether a demo is available.
 * @param {string} [props.size='medium'] - Size variant ('small'|'medium'|'large').
 * @returns {JSX.Element} The demo button.
 */
const DemoDownloadButton = ({ demoUrl, hasDemo, size = 'medium' }) => {
  const { t } = useTranslation();
  const sizeClass = `demo-button-${size}`;

  const handleClick = (e) => {
    e.stopPropagation();
    if (demoUrl) {
      window.open(demoUrl, '_blank');
    }
  };

  if (!hasDemo) {
    return (
      <button
        className={`demo-button ${sizeClass} disabled`}
        disabled
        title={t('demo.unavailable')}
      >
        <span className="demo-icon">📦</span>
        <span className="demo-text">{t('demo.none')}</span>
      </button>
    );
  }

  return (
    <button
      className={`demo-button ${sizeClass}`}
      onClick={handleClick}
      title={t('demo.download')}
    >
      <span className="demo-icon">📥</span>
      <span className="demo-text">{t('demo.label')}</span>
    </button>
  );
};

export default DemoDownloadButton;
